<template>
  <div>
    <div class="wScreenArea">
      <el-card class="box-card">
        <div slot="header" class="wScreenCardHeader">
          <span>筛选查询</span>
        </div>
        <el-form label-position="left" label-width="90px" @submit.native.prevent>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="门店">
                <el-select v-model="selectedStore" placeholder="选择门店" style="width: 320px;" @change="onStoreChange">
                  <el-option v-for="s in stores" :key="s.id" :label="s.name" :value="s.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="商品">
                <el-select v-model="selectedGoods" placeholder="选择商品" filterable clearable :disabled="!selectedStore" @visible-change="v=>{ if(v) fetchGoodsOptionsForStore() }" style="width: 320px;">
                  <el-option v-for="g in goodsOptions" :key="g.id" :label="g.goodsName" :value="g.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="时间范围">
                <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 100%" />
              </el-form-item>
            </el-col>
            <el-col :span="4" style="display:flex;align-items:center;gap:8px;">
              <el-button @click="applyFilter">查询</el-button>
              <el-button @click="resetFilter">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
    </div>

    <div class="wTableArea">
      <el-table border :data="paginatedData" v-loading="loading">
        <el-table-column prop="storeName" label="门店" align="center" width="180" />
        <el-table-column prop="goodsName" label="商品" align="center" />
        <el-table-column prop="quantity" label="销量" align="center" width="100" />
        <el-table-column label="销售额(元)" align="center" width="140">
          <template slot-scope="scope">{{ scope.row.totalPrice.toFixed(2) }}</template>
        </el-table-column>
          <el-table-column label="顾客价" align="center" width="100">
              <template slot-scope="scope">{{ scope.row.vipPrice ? scope.row.vipPrice.toFixed(2) : '-' }}</template>
          </el-table-column>

          <el-table-column label="顾客价销量" align="center" width="140">
              <template slot-scope="scope">{{ scope.row.vipSale || 0 }}</template>
          </el-table-column>
          <el-table-column label="顾客价销售额" align="center" width="140">
              <template slot-scope="scope">{{ scope.row.vipPriceSale ? scope.row.vipPriceSale.toFixed(2) : '0.00' }}</template>
          </el-table-column>

          <el-table-column label="会员价" align="center" width="100">
              <template slot-scope="scope">{{ scope.row.customerPrice ? scope.row.customerPrice.toFixed(2) : '-' }}</template>
          </el-table-column>
          <el-table-column label="会员价销量" align="center" width="80">
              <template slot-scope="scope">{{ scope.row.customerSale || 0 }}</template>
          </el-table-column>
          <el-table-column label="会员价销售额" align="center" width="120">
              <template slot-scope="scope">{{ scope.row.customerPriceSale ? scope.row.customerPriceSale.toFixed(2) : '0.00' }}</template>
          </el-table-column>

      </el-table>
      
      <!-- 分页组件 -->
      <div class="wPagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getStoreManagerListApi, getStoreGoodsListApi, getGoodsStatisticsApi } from '@/network/wApi.js'
import ElementUI from 'element-ui';

export default {
  data() {
    return {
      selectedStore: '',
      stores: [],
      selectedGoods: '',
      goodsOptions: [],
      dateRange: '',
      filteredRowsAll: [], // 完整数据
      paginatedData: [],   // 当前页数据
      loading: false,
      // 分页相关属性
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted() {
    this.getStoreList();
  },
  methods: {
    // 获取门店列表
    getStoreList() {
      this.loading = true;
      
      // 从localStorage获取用户信息
      let userInfo = localStorage.getItem('USER_INFO');
      console.log('userInfo:', userInfo);
      let userId = '';
      if (userInfo) {
        try {
          userInfo = JSON.parse(userInfo);
          userId = userInfo.id || '';
          console.log('获取到的userId:', userId);
        } catch (e) {
          console.error('解析用户信息失败:', e);
        }
      }
      
      // 调用接口时传入userId
      getStoreManagerListApi({ userId })
        .then(res => {
          // 根据request.js的响应拦截器实现，当code=200时，返回的是res.data.data
          // 根据用户提供的响应式数据结构，这应该包含records数组
          if (res && Array.isArray(res)) {
            // 如果直接返回的是数组
            this.stores = res.map(store => ({
              id: store.id,
              name: store.storeName
            }));
            // 默认选择第一个门店
            if (this.stores.length > 0) {
              this.selectedStore = this.stores[0].id;
              // 自动加载对应商品列表
              this.fetchGoodsOptionsForStore();
            }
          } else if (res && res.records && Array.isArray(res.records)) {
            // 如果返回的对象包含records数组
            this.stores = res.records.map(store => ({
              id: store.id,
              name: store.storeName
            }));
            // 默认选择第一个门店
            if (this.stores.length > 0) {
              this.selectedStore = this.stores[0].id;
              // 自动加载对应商品列表
              this.fetchGoodsOptionsForStore();
            }
          } else {
            this.stores = [];
            ElementUI.Message({
              message: '暂无门店数据',
              type: 'warning'
            });
          }
        })
        .catch(err => {
          console.error('获取门店列表失败:', err);
          this.stores = [];
          ElementUI.Message({
            message: '获取门店列表失败',
            type: 'error'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // 获取商品选项
    fetchGoodsOptionsForStore() {
      // 检查是否已选择门店
      if (!this.selectedStore) {
        return;
      }
      
      this.loading = true;
      // 调用获取商品列表的API，传入门店ID、商品类型和pageSize参数
      getStoreGoodsListApi({
        storeId: this.selectedStore,
        goodType: 1,  // 根据提供的接口参数，商品类型固定为1
        'pageModel.pageSize': 100,
        pageNo: 1,
        pageSize: 100
      })
        .then(res => {
          // 清空之前的商品选项
          this.goodsOptions = [];
          
          // 处理API返回的数据
          if (res && res.records && Array.isArray(res.records)) {
            // 格式化商品数据为下拉框需要的格式，与表格字段保持一致
            this.goodsOptions = res.records.map(goods => ({
              id: goods.id,        // 商品ID
              goodsName: goods.name  // 商品名称，与表格字段保持一致
            }));
            
            // 不默认选择商品，保持为空
            this.selectedGoods = '';
            // 商品列表加载完成后，自动查询当前门店所有商品的统计数据
            this.applyFilter();
          } else {
            ElementUI.Message({
              message: '暂无商品数据',
              type: 'warning'
            });
          }
        })
        .catch(err => {
          console.error('获取商品列表失败:', err);
          this.goodsOptions = [];
          ElementUI.Message({
            message: '获取商品列表失败',
            type: 'error'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
      
      // 处理门店选择变化
      onStoreChange() {
        // 当门店选择变化时，刷新商品列表
        this.fetchGoodsOptionsForStore();
      },
      
      // 应用筛选
      applyFilter() {
        // 检查必要的筛选条件 - 只检查门店ID
        if (!this.selectedStore) {
          ElementUI.Message({
            message: '请选择门店',
            type: 'warning'
          });
          return;
        }

        this.loading = true;
        
        // 构建查询参数
        const queryParams = {
          storeId: this.selectedStore
        };
        
        // 如果选择了商品，添加商品ID参数
        if (this.selectedGoods) {
          queryParams.goodId = this.selectedGoods;
        }
        
        // 如果选择了时间范围，添加时间参数
        if (this.dateRange && this.dateRange.length === 2) {
          queryParams.start = this.dateRange[0];
          queryParams.end = this.dateRange[1];
        }
        
        // 调用获取商品销量和销售额的API
        getGoodsStatisticsApi(queryParams)
          .then(res => {
            // 清空之前的数据
            this.filteredRowsAll = [];
            
            // 处理API返回的数据
            // 根据request.js的响应拦截器，当code=200时，返回的是res.data.data
            if (res && Array.isArray(res)) {
              // 获取门店信息
              const selectedStoreInfo = this.stores.find(store => store.id === this.selectedStore) || {};
              const storeName = selectedStoreInfo.name || '';
              
              // 格式化数据为表格需要的格式
              this.filteredRowsAll = res.map(item => ({
                storeName: storeName,
                goodsName: item.goodsName,
                quantity: item.num,
                unitPrice: item.price / item.num, // 计算单价（销售额/销量）
                totalPrice: item.price, // 直接使用API返回的销售额
                goodsId: item.goodsId,
                    // 价格信息
                customerPrice: item.customerPrice,          // 顾客价（商品售价）
                vipPrice: item.vipPrice,                    // 会员价
                
                
                // 顾客统计
                customerSale: item.customerSale,            // 顾客销量
                customerPriceSale: item.customerPriceSale,  // 顾客销售额
                
                // 会员统计
                vipSale: item.vipSale,                      // 会员销量
                vipPriceSale: item.vipPriceSale,            // 会员销售额
              }));
              
              // 设置总条数和当前页数据
              this.total = this.filteredRowsAll.length;
              this.setCurrentPageData();
            } else {
              ElementUI.Message({
                message: '暂无统计数据',
                type: 'warning'
              });
            }
          })
          .catch(err => {
            console.error('获取商品统计数据失败:', err);
            this.filteredRowsAll = [];
            ElementUI.Message({
              message: '获取商品统计数据失败',
              type: 'error'
            });
          })
          .finally(() => {
            this.loading = false;
          });
      },
      
      // 重置筛选
      resetFilter() {
        this.selectedStore = '';
        this.selectedGoods = '';
        this.dateRange = '';
        this.filteredRowsAll = [];
        this.paginatedData = [];
        this.goodsOptions = [];
        this.currentPage = 1;
        this.total = 0;
      },
      
      // 设置当前页数据
      setCurrentPageData() {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;
        this.paginatedData = this.filteredRowsAll.slice(start, end);
      },
      
      // 处理页码变化
      handleCurrentChange(val) {
        this.currentPage = val;
        this.setCurrentPageData();
      },
      
      // 处理每页条数变化
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1;
        this.setCurrentPageData();
      }
  }
}
</script>

<style lang="less" scoped>
@import "@/assets/css/publicStyle.less";

.wScreenCardHeader-right {
  display: flex;
  align-items: center;
}
</style>


